import React, { useEffect } from "react";
import styles from "./orderDetails.module.scss";
import OrderIdDetails from "../../components/uiComponents/orderIdDetails/OrderIdDetails";
import { Paper } from "@mui/material";
import OrderTogether from "../../components/uiComponents/orderTogether/OrderTogether";
import OrderProductDetails from "../../components/uiComponents/orderProductDetails/OrderProductDetails";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { connect, useDispatch } from "react-redux";
import { getOrdersByCartBundleId } from "../../store/actions";
import {
  getOtherObjectsFromArray,
  getSimilarObjectsFromArray,
} from "../../utils/common/CommonFunctions";

// const orderedTogetherData = [
//   {
//     orderId: "OR34284",
//     cartBundleId: "SFXCV98834",
//     customerId: "SCEEBV98834",
//     status: "Shipped",
//   },
//   {
//     orderId: "OR34254",
//     cartBundleId: "SFXCV98834",
//     customerId: "SCEEBV98834",
//     status: "Shipped",
//   },
// ];

const OrderDetails = ({ orders = [], order = {} }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrdersByCartBundleId({ id: order?.cartBundleId }));
  }, []);
  return (
    <div className={styles.container}>
      <StatusCard
        leftContent="ORDER DETAILS" // or any icon/component
      />
      <div className={styles.top}>
        <OrderIdDetails />
      </div>
      <Paper className={styles.middle}>
        <OrderProductDetails />
      </Paper>
      {/* <Paper className={styles.bottom}>
        <div className={styles.orderTitle}>Ordered Together</div>
        <OrderTogether data={orders} />
      </Paper> */}
      {/* {getOtherObjectsFromArray(orders, "id", order?.id)?.length > 0 && (
        <Paper className={styles.bottom}>
          <div className={styles.orderTitle}>Ordered Together</div>
          <OrderTogether
            data={getOtherObjectsFromArray(orders, "id", order?.id) || []}
          />
        </Paper>
      )} */}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    orders: state?.orders?.orders,
    order: state?.orders?.order,
  };
};

export default connect(mapStateToProps, null)(OrderDetails);
